import React from 'react';

const NotFound = props => {
    return (

      <div id="contentpage">
        <div className="overviewContainer">

         <h3 style={{color: 'var(--text-primary)'}}>You took a wrong turn, mate.</h3>
         
        </div>
      </div>

    );
};

export default NotFound;